<pm-widget-base-wrapper [isLoading]="isLoading" [name]="name">
  <ng-template
    pmWidgetTitle
    [infoTooltipText]="
      (isDialogInstance
        ? 'RESULT.INSIGHTS.WIDGETS.YEARLY_PORTFOLIO_TOTALS.TOOLTIP_DIALOG'
        : 'RESULT.INSIGHTS.WIDGETS.YEARLY_PORTFOLIO_TOTALS.TOOLTIP'
      ) | translate
    "
  >
    {{ 'RESULT.INSIGHTS.WIDGETS.YEARLY_PORTFOLIO_TOTALS.TITLE' | translate }}
  </ng-template>

  <ng-template pmWidgetHeader>
    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER">
      <pm-form-input-select
        [allowSearching]="true"
        [ngModel]="currentGroupName"
        (ngModelChange)="onGroupChange($event)"
        [data]="groupsSelectOptions()"
      />
    </pm-form-field>
    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_YEARS">
      <pm-form-input-select
        [allowSelectAll]="true"
        [selectableItemsLimit]="MAX_NUMBER_OF_SELECTIONS"
        [ngModel]="selectedYears"
        [multiSelect]="true"
        [clearable]="true"
        [allowUnselect]="true"
        (ngModelChange)="onYearChange($event)"
        [data]="yearsSelectOptions()"
      />
    </pm-form-field>
  </ng-template>

  <ng-template pmWidgetContent>
    @if (this.isError) {
      <div class="flex justify-center items-center h-full text-center p-4">
        <pm-h3>
          {{ 'RESULT.INSIGHTS.GENERAL.TECHNICAL_ERROR' | translate }}
        </pm-h3>
      </div>
    } @else {
      <highcharts-chart
        id="portfolio-totals-chart"
        [(update)]="chartUpdated"
        (chartInstance)="setChartInstance($event)"
        [oneToOne]="true"
        [options]="this.chartOptions()"
        class="!h-full !w-full block"
      >
      </highcharts-chart>
    }
  </ng-template>
  <ng-template pmWidgetActions>
    @if (isDialogInstance) {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.EXIT_FULL_SCREEN_TOOLTIP'"
        (handleClick)="exitFullScreen()"
        [icon]="scanIcon"
      />
    } @else {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.FULL_SCREEN_TOOLTIP'"
        [icon]="scanIcon"
        (handleClick)="
          showFullScreen(PortfolioTotalsMultiYearWidgetComponent, {
            targetUnit: this.targetUnit,
            filter: this.currentGroupName,
            years: currentYearsAsStringArray,
          })
        "
      />
    }
  </ng-template>
</pm-widget-base-wrapper>
